import React, {Component} from 'react'
import {formatMoney} from 'accounting-js'

export default class ProductOptions extends Component {
  constructor(props){
    super(props);
  }

  each_option(opt){
    return (<div className="row" key={opt.id}>
      {opt.label}
      </div>);
  }

  render(){
    let rows = this.props.options.map((o) => {return this.each_option(o);}); 
    return (
      <div>
      <h1>Options</h1>
      {rows}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/app/components/product_options.jsx